export default __webpack_public_path__ + "static/media/CL04.1.3380a3b5.mp3";